export const endPoints = {
  CRM_SETTINGS: '/v1/crm/crm-role/filter',
  CRM_SETTINGS_ROLE: '/v1/crm/crm-role',
  CRM_SETTINGS_COMPACT: '/v1/crm/crm-role/compact'
};
